import { Component, OnInit, ViewChild, AfterViewInit, ViewEncapsulation, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { UserService } from '../../../shared/services/user.service';
import * as _ from 'lodash';
import { UpdateUser } from '../../../queries/users.model';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Apollo } from 'apollo-angular';




@Component({
  selector: 'my-restrict-user',
  template: require('./restrict-user.component.html'),
  styles: [require('./restrict-user.component.scss'), require('../../user-form/new-user-form.component.scss')],
  encapsulation: ViewEncapsulation.None
})

export class RestrictUserComponent implements OnInit, AfterViewInit {

  public appName: string;
  public userId: string;
  public featureSelected = '';
  public appNameEdit: string;
  public appToDelete: string;
  public featureSelectedEdit = '';
  public selectedAppFeatures = [];
  public editSelectedAppFeatures = [];
  public editAppFeatures = [];
  public restrictedApplications = [];
  public featuresToAddUser = [];
  public user: object;
  public appExists: boolean = false;
  public featureExists: boolean = false;
  public featureExistsCreate: boolean = false;
  public cancelClicked: boolean = false;
  public firstName: string;

  restrictUserForm: FormGroup;
  restrictUserFormEdit: FormGroup;
  deleteAppForm: FormGroup;
  @ViewChild('lgModal') public lgModal:ModalDirective;
  @Output() edited:EventEmitter<string> = new EventEmitter();

  constructor(public userService: UserService,
    private formBuilder: FormBuilder,
    private apollo: Apollo){
  };

  ngOnInit(){
    this.user = _.cloneDeep(this.userService.getExternalUser());
    this.userId = this.user['_id'];
    this.createForm();
    this.loadData();
    this.editForm();
    this.deleteRestrictedAppForm();
  }

  ngAfterViewInit() {
    this.lgModal.show();
  }

  cancelForm() {
    if (this.lgModal.isShown) {
      this.lgModal.hide();
    }
    this.userService.userRestrict = false;
  }

  selectedApp(event) {
    this.selectedAppFeatures = [];
    this.selectedAppFeatures.push(...event.item.features);
  }

  selectedAppEdit(event) {
    this.editAppFeatures = [];
    this.editSelectedAppFeatures = [];
    const getApp = this.restrictedApplications.find((o) => o._id === event.item.id);
    this.editAppFeatures.push(...getApp.features);
    this.editSelectedAppFeatures.push(...event.item.features);
  }

  addFeatureToSelectedUserApp(event) {
    let isFeatureAlreadySelected = _.some(this.featuresToAddUser, function(obj) {
      return (obj && obj['_id']) === event.item._id;
    });
    if(isFeatureAlreadySelected) {
      this.featureExistsCreate = true;
    } else {
      this.featuresToAddUser.push(event.item);
      this.featureExistsCreate = false;
      this.restrictUserForm.controls['featureSelected'].patchValue('');
    }
  }

  editFeatureToSelectedUserApp(event) {
    let isFeatureAlreadySelected = _.some(this.editSelectedAppFeatures, function(obj) {
      return (obj && obj['_id']) === event.item._id;
    });
    if(isFeatureAlreadySelected) {
      this.featureExists = true;
    } else {
    this.editSelectedAppFeatures.push(event.item);
    this.featureExists = false;
    this.restrictUserFormEdit.controls['featureSelectedEdit'].patchValue('');
    }
  }

  removeItemFromList(index) {
    this.featuresToAddUser.splice(index, 1);
  }

  removeItemFromEditList(index) {
    this.editSelectedAppFeatures.splice(index, 1);
  }

  restrictUser(value) {
    delete this.user['_id'];
    let isAppExists = _.some(this.user['restrictedApplicationsAccess'], function(obj) {
      return (obj && obj['id']) === value.appName;
    });

    if (!isAppExists) {
      if(!this.user['restrictedApplicationsAccess']) {
        const restrictions = [
          {
          id: value.appName,
          features: this.featuresToAddUser
        }];
        this.user['restrictedApplicationsAccess'] = restrictions;
      } else {
        const restrictions = [
          ...this.user['restrictedApplicationsAccess'],
          {
          id: value.appName,
          features: this.featuresToAddUser
        }];
        this.user['restrictedApplicationsAccess'] = restrictions;
      }
      this.apollo.mutate({
        mutation: UpdateUser,
        variables: {
          ID: this.userId,
          UserInput: this.user
        }
      })
      .subscribe((data) => {
        console.log('Success', data);
      }, (error) => {
        console.log('There was an error sending the query', error.message.split('error'));
      }, () => {
        this.userService.userRestrict = false;
        this.edited.next();
        this.appExists = false;
        this.lgModal.hide();
      });
    } else  {
      this.appExists = true;
    }
  }

  restrictUserEdit(value) {
    delete this.user['_id'];
    let existingAppIndex = _.findIndex(this.user['restrictedApplicationsAccess'], function(obj) {
      return (obj && obj['id']) === value.appNameEdit;
    });
    const restrictions = {
      id: value.appNameEdit,
      features: this.editSelectedAppFeatures
    };

    if (existingAppIndex >= 0) {
      this.user['restrictedApplicationsAccess'][existingAppIndex] = restrictions;
      this.apollo.mutate({
        mutation: UpdateUser,
        variables: {
          ID: this.userId,
          UserInput: this.user
        }
      })
      .subscribe((data) => {
        console.log('Success Info', data);
      }, (error) => {
        console.log('There was an error sending the query', error.message.split('error'));
      }, () => {
        this.userService.userRestrict = false;
        this.edited.next();
        this.lgModal.hide();
      });
    }
  }

  deleteApplication(value) {
    delete this.user['_id'];
    let existingAppIndex = _.findIndex(this.user['restrictedApplicationsAccess'], function(obj) {
      return (obj && obj['id']) === value.appToDelete;
    });

    if (existingAppIndex >= 0) {
      this.user['restrictedApplicationsAccess'].splice(existingAppIndex, 1);
      this.apollo.mutate({
        mutation: UpdateUser,
        variables: {
          ID: this.userId,
          UserInput: this.user
        }
      })
      .subscribe((data) => {
        console.log('Success Info', data);
      }, (error) => {
        console.log('there was an error sending the query', error.message.split('error'));
      }, () => {
        this.userService.userRestrict = false;
        this.edited.next();
        this.lgModal.hide();
      });
    }
  }

  createForm() {
    this.restrictUserForm = this.formBuilder.group({
      appName: new FormControl(this.appName, Validators.required),
      featureSelected: new FormControl(this.featureSelected, Validators.required),
    });
  }

  editForm() {
    this.restrictUserFormEdit = this.formBuilder.group({
      appNameEdit: new FormControl(this.appNameEdit, Validators.required),
      featureSelectedEdit: new FormControl(this.featureSelectedEdit, Validators.required),
    });
  }

  deleteRestrictedAppForm() {
    this.deleteAppForm = this.formBuilder.group({
      appToDelete: new FormControl(this.appToDelete, Validators.required)
    });
  }

  loadData() {
    this.userService.loadAllRestrictedApplications().subscribe((data) => {
      this.restrictedApplications = data['loadAllRestrictedApplications'];
    });
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/users/app-restrictions/restrict-user/restrict-user.component.ts